import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./i18n/i18n";
import App from "./App.tsx";
import { changeLocale } from "./i18n";
import { applyConfigAccent } from "./theme";

// Neutral canvas until GET /v1/config applies the avatar accent.
document.documentElement.style.background = "#f9fafb";

// Loader passes accent after its config fetch — avoids orange brand flash on open.
const accentFromUrl = new URLSearchParams(window.location.search).get("accent");
if (accentFromUrl) {
  applyConfigAccent(accentFromUrl);
}

void changeLocale("en");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
